export default {
    imageDashboardTransaction: {
        action: 'Aktion',
        transactionId: 'Transaktions-ID',
        variationCount: 'Anzahl der Variationen',
        date: 'Datum',
        cost: 'Kosten',
        description: 'Beschreibung',
        selectedImage: 'Ausgewähltes Bild',
        goTo: 'Gehe zu',
    },
};
